import { render, staticRenderFns } from "./ui-prize.vue?vue&type=template&id=23e1cbcd&scoped=true&"
import script from "./ui-prize.vue?vue&type=script&lang=js&"
export * from "./ui-prize.vue?vue&type=script&lang=js&"
import style0 from "./ui-prize.vue?vue&type=style&index=0&id=23e1cbcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e1cbcd",
  null
  
)

export default component.exports